if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        window.addEventListener('shopify:section:load', (e) => {
          this.init();
        });
      }
      this.init();


    }

    init() {
      // Cible uniquement le swiper à l’intérieur de ce composant (drawer + page panier)
      const swiperArea = this.querySelector('.cart-drawer__swiper');
      if (!swiperArea) {
        return;
      }
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
        this.slider = null;
      }
      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}
